import { OverlayService } from '$core/shell/overlay/overlay.service';
import { Directive, HostListener } from '@angular/core';
import { RouterLinkActive } from '@angular/router';

@Directive({
  selector: '[appCloseOverlayForActiveLink]',
})
export class CloseOverlayForActiveLinkDirective {
  constructor(
    private rla: RouterLinkActive,
    private overlayService: OverlayService
  ) {}

  @HostListener('click')
  public onclick() {
    if (this.overlayService.isOpen && this.rla.isActive) {
      this.overlayService.close();
    }
  }
}
